import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataTrackableInterface } from '../data/trackable.interface';
import { GtmStatsAdapterEcommerceCheckout } from './ecommerce-checkout';
import { GtmStatsAdapterEcommercePurchase } from './ecommerce-purchase';
import { GtmStatsAdapterEventLead } from './event-lead';

export class GtmStatsAdapterEntityLeadClick implements StatsAdapterInterface {
  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataTrackableInterface[] {
    const data: GtmStatsDataTrackableInterface[] = [];

    switch (this.context.local.lead.medium) {
      // Phone/SMS/Whatsapp lead
      case 'phone':
      case 'sms':
      case 'whatsapp':
        // Convert to ecommerce purchase and to event lead
        data.push(
          new GtmStatsAdapterEcommercePurchase(this.entity, this.context).getData(),
          new GtmStatsAdapterEventLead(this.entity, this.context).getData()
        );

        break;

      // Email/Call Back lead
      case 'email':
      case 'call_back':
        // Convert to ecommerce checkout
        data.push(new GtmStatsAdapterEcommerceCheckout(this.entity, this.context).getData());

        break;
    }

    return data;
  }
}
